import type { MouseEvent, ReactNode } from 'react';
import { Link, type LinkProps } from '@gravity-ui/uikit';
import { useRouter } from '@tanstack/react-router';

/**
 * Ссылка Gravity, которая переходит роутером: обычный щелчок — без
 * перезагрузки, щелчок с Ctrl/⌘ или средней кнопкой — новая вкладка, как у
 * любой ссылки в консоли.
 */

export function isPlainClick(event: MouseEvent): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

export function useGo(): (href: string) => void {
  const router = useRouter();
  return (href) => {
    router.history.push(href);
  };
}

export function RouterLink({
  to,
  children,
  view,
  className,
}: {
  to: string;
  children: ReactNode;
  view?: LinkProps['view'];
  className?: string;
}) {
  const go = useGo();
  return (
    <Link
      href={to}
      {...(view === undefined ? {} : { view })}
      {...(className === undefined ? {} : { className })}
      onClick={(event) => {
        if (!isPlainClick(event)) return;
        event.preventDefault();
        go(to);
      }}
    >
      {children}
    </Link>
  );
}
